export const iconFontAwesomeBuildingsTreeCity = (
	<i className="fa-solid fa-tree-city"></i>
);
